import { NgModule } from '@angular/core';
import { AppEventsModule } from './app-events/app-events.module';

@NgModule({
  imports: [AppEventsModule],
})
export class CoreModule {}
